export const CLICK_ID_KEYS = ['gclid', 'fbclid', 'ttclid', 'msclkid'] as const;

export type ClickIdKeyType = (typeof CLICK_ID_KEYS)[number];
